import graphql__70356ec513c64395a47e from "./__generated__/AnswerPreviewEvents_answer.graphql.js";import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import { ANSWER_CHOICE_VALUE_OTHER } from "../Answer/AnswerChoiceWithOther";

const AnswerPreviewEvents = props => {
  const answer = useFragment(AnswerPreviewEvents_answer, props.answer);
  const { eventIds, formField, other, otherValue } = answer;

  const eventsList = eventIds.map(id => {
    const event = formField.options.find(option => option.id === id);

    if (!event) return null;

    return <li key={event.id}>{event.name}</li>;
  });

  if (other) {
    eventsList.push(
      <li key={ANSWER_CHOICE_VALUE_OTHER}>
        <b>{formField.otherFieldLabel}: </b>
        {otherValue}
      </li>
    );
  }

  const listClassName = classNames([
    "form-answer-events-values",
    "form-answer-events-values-" + eventsList.length
  ]);

  return <ul className={listClassName}>{eventsList}</ul>;
};

const AnswerPreviewEvents_answer = graphql__70356ec513c64395a47e;

export default AnswerPreviewEvents;
